import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from '../components/Landing';
import { Lobby } from '../components/Lobby';
import { GameRoom } from '../components/GameRoom';

// Version number to force cache refresh - update this when deploying
const APP_VERSION = '2.0.0';
console.log(`Guess Hue v${APP_VERSION} - Color grid update`);

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/lobby" element={<Lobby />} />
          <Route path="/game/:roomId" element={<GameRoom />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;